'use client';

import type { PaymentMethodId } from '@/entities/order';
import type { PaymentMethod } from '@/entities/payment';
import { Button } from '@/shared/ui/button';
import { ChoiceCard } from '@/shared/ui/choice-card';
import { Icon } from '@/shared/ui/icon';

import styles from './payment-step.module.scss';

export type PaymentStepProps = {
  methods: PaymentMethod[];
  value: PaymentMethodId;
  onChange: (value: PaymentMethodId) => void;
  onPay: () => void;
  pending: boolean;
  error: string;
};

/** Step 03 "Оплата" (05B-2). Cards/SBP/parts go through the CloudPayments mock; "при получении" skips it. */
export function PaymentStep({ methods, value, onChange, onPay, pending, error }: PaymentStepProps) {
  return (
    <div className={styles.root}>
      <h2 className={styles.title}>Оплата</h2>
      <div className={styles.methods} role="radiogroup" aria-label="Способ оплаты">
        {methods.map((method) => (
          <ChoiceCard
            key={method.id}
            name="payment-method"
            value={method.id}
            checked={value === method.id}
            compact
            onSelect={() => onChange(method.id)}
            disabled={!method.available}
            title={method.title}
            description={method.description}
          />
        ))}
      </div>
      {error && (
        <p className={styles.error} role="alert">
          {error}
        </p>
      )}
      <Button size="lg" className={styles.pay} loading={pending} onClick={onPay}>
        {value === 'cod' ? 'Оформить заказ' : 'Оплатить заказ'}{' '}
        <Icon name="arrow-long-right" size={18} strokeWidth={1.3} />
      </Button>
    </div>
  );
}
